export default "__VITE_ASSET__Cx600Gx9__"